export const kassaStatusesMap = {
  NEW_APPLICATION: 'Новая заявка',
  REGISTRATION_PENDING: 'Идет регистрация',
  OK: 'Работает',
  DEACTIVATED: 'Деактивирована',
};

export const kassaStatuses = [
  { value: 'NEW_APPLICATION', text: 'Новая заявка' },
  { value: 'REGISTRATION_PENDING', text: 'Идет регистрация' },
  { value: 'OK', text: 'Работает' },
  { value: 'DEACTIVATED', text: 'Деактивирована' },
];

export const operator = [
  { value: 'TRANSTELECOM', text: 'Транстелеком' },
  { value: 'KAZAKHTELECOM', text: 'Казактелеком' },
];

export const kassaParnters = [{ value: 'UKASSA', text: 'UKASSA' }];

export const operationType = [
  {
    text: 'Покупка',
    value: 'PURCHASE',
  },
  {
    text: 'Возврат покупки',
    value: 'PURCHASE_REFUND',
  },
  {
    text: 'Продажа',
    value: 'SELL',
  },
  {
    text: 'Возврат продажи',
    value: 'SELL_REFUND',
  },
];

export const operationTypeMap = {
  0: 'Покупка',
  1: 'Возврат покупки',
  2: 'Продажа',
  3: 'Возврат продажи',
};

export const checkPaymentsType = [
  {
    text: 'Наличными',
    value: 'CASH_PAYMENT',
  },
  {
    text: 'Картой',
    value: 'CARD_PAYMENT',
  },
  {
    text: 'Смешанная',
    value: 'MIXED_PAYMENT',
  },
];

export const checkPaymentsTypeMap = {
  0: 'Наличными',
  1: 'Картой',
  2: 'Смешанная',
};
